/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TimePickerDefault } from './time-picker-default.story';
export { default as TimePickerError } from './time-picker-error.story';
export { default as TimePickerInDialog } from './time-picker-in-dialog.story';
export { default as TimePickerInPopoverDialog } from './time-picker-in-popover-dialog.story';
export { default as TimePickerWithSeconds } from './time-picker-with-seconds.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import TimePickerDefaultSrcRaw from './time-picker-default.story.tsx?raw';
import TimePickerErrorSrcRaw from './time-picker-error.story.tsx?raw';
import TimePickerInDialogSrcRaw from './time-picker-in-dialog.story.tsx?raw';
import TimePickerInPopoverDialogSrcRaw from './time-picker-in-popover-dialog.story.tsx?raw';
import TimePickerWithSecondsSrcRaw from './time-picker-with-seconds.story.tsx?raw';

export const TimePickerDefaultSrc = removeLicenseHeader(
  TimePickerDefaultSrcRaw,
);
export const TimePickerErrorSrc = removeLicenseHeader(TimePickerErrorSrcRaw);
export const TimePickerInDialogSrc = removeLicenseHeader(
  TimePickerInDialogSrcRaw,
);
export const TimePickerInPopoverDialogSrc = removeLicenseHeader(
  TimePickerInPopoverDialogSrcRaw,
);
export const TimePickerWithSecondsSrc = removeLicenseHeader(
  TimePickerWithSecondsSrcRaw,
);
